import { render, staticRenderFns } from "./ViewAudienceAvailabilityModal.vue?vue&type=template&id=08c48567&"
import script from "./ViewAudienceAvailabilityModal.vue?vue&type=script&lang=js&"
export * from "./ViewAudienceAvailabilityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports